import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import screens from '../../';
import SPIN_PHASE from '../../../api/GameInterface/helpers/spinPhases';
import { invalidatePiggy, usePiggyBankState } from '../../../state/query/piggyBank';
import { normalizeTimestamp } from '../../../utils/TimestampManager';
import QueryParamProxy from '../../../utils/queryParamProxy';
import routeParamConstants from '../../../utils/routeParamConstants';
import { sendPiggyBankEvent } from '../analytics/piggyBankLogger';
import { PIGGY_BANK_EVENT_TYPES } from '../constants';
import { generatePiggyBankIcon } from '../utils/generatePiggyBankRendering';
import { getFillUpProgressPercentage } from '../utils/helpers';
import usePiggyBankTooltips from './usePiggyBankTooltips';
import { GAME_ROOMS_CONTAINER } from '../../Home/constants';
var usePiggyBankWidget = function usePiggyBankWidget() {
  var _piggyBankSelector$da, _piggyBankFeatureStat, _piggyBankFeatureStat2, _piggyBankFeatureStat3, _piggyBankFeatureStat4, _piggyBankFeatureStat5, _piggyBankFeatureStat6;
  var dispatch = useDispatch();
  var piggyBankSelector = usePiggyBankState();
  var piggyBankFeatureState = piggyBankSelector === null || piggyBankSelector === void 0 || (_piggyBankSelector$da = piggyBankSelector.data) === null || _piggyBankSelector$da === void 0 ? void 0 : _piggyBankSelector$da.piggyBankFeatureState;
  var piggyBankCounterValue = (_piggyBankFeatureStat = piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat2 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat2 === void 0 || (_piggyBankFeatureStat2 = _piggyBankFeatureStat2.counter) === null || _piggyBankFeatureStat2 === void 0 ? void 0 : _piggyBankFeatureStat2.value) !== null && _piggyBankFeatureStat !== void 0 ? _piggyBankFeatureStat : 0;
  var piggyBankCurrentProgress = piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat3 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat3 === void 0 ? void 0 : _piggyBankFeatureStat3.progress;
  var piggyBankDefaultBet = (_piggyBankFeatureStat4 = piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat5 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat5 === void 0 ? void 0 : _piggyBankFeatureStat5.defaultBet) !== null && _piggyBankFeatureStat4 !== void 0 ? _piggyBankFeatureStat4 : 1;
  var coolDownTimestamp = (_piggyBankFeatureStat6 = piggyBankFeatureState === null || piggyBankFeatureState === void 0 ? void 0 : piggyBankFeatureState.coolDownTimestamp) !== null && _piggyBankFeatureStat6 !== void 0 ? _piggyBankFeatureStat6 : 0;
  var piggyBankAssets = useSelector(function (state) {
    return state.assetsPackage.assets.PIGGY_BANK_FEATURE || {};
  }, shallowEqual);
  var lastSpinEvents = useSelector(function (state) {
    return state.lastSpinEvents;
  }, shallowEqual);
  var gameType = useSelector(function (state) {
    var _state$gameInfo;
    return (_state$gameInfo = state.gameInfo) === null || _state$gameInfo === void 0 ? void 0 : _state$gameInfo.gameType;
  }, shallowEqual);
  var _useState = useState(piggyBankCounterValue),
    _useState2 = _slicedToArray(_useState, 2),
    localCounterValue = _useState2[0],
    setLocalCounterValue = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    forceUpdate = _useState4[1];
  useEffect(function () {
    if ((lastSpinEvents === null || lastSpinEvents === void 0 ? void 0 : lastSpinEvents.spinPhase) === SPIN_PHASE.WAGE && gameType !== GAME_ROOMS_CONTAINER.TABLE && piggyBankCurrentProgress >= 0) {
      setLocalCounterValue(function (prev) {
        var _ref;
        return prev + Number((_ref = (lastSpinEvents === null || lastSpinEvents === void 0 ? void 0 : lastSpinEvents.amount) / piggyBankDefaultBet) !== null && _ref !== void 0 ? _ref : 0);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSpinEvents === null || lastSpinEvents === void 0 ? void 0 : lastSpinEvents.createdTimestamp]);
  useEffect(function () {
    if (piggyBankCurrentProgress >= 0) setLocalCounterValue(piggyBankCounterValue);
  }, [piggyBankCurrentProgress, piggyBankCounterValue]);
  useEffect(function () {
    if (!coolDownTimestamp) return;
    var normalized = normalizeTimestamp(coolDownTimestamp);
    var now = Date.now();
    if (normalized <= now) return;
    var delay = normalized - now + 1000;
    var timer = setTimeout(function () {
      return forceUpdate(function (v) {
        return v + 1;
      });
    }, delay);
    return function () {
      return clearTimeout(timer);
    };
  }, [coolDownTimestamp]);
  var _generatePiggyBankIco = generatePiggyBankIcon(piggyBankSelector, piggyBankAssets),
    piggyBankIcon = _generatePiggyBankIco.piggyBankIcon,
    disabledAnimation = _generatePiggyBankIco.disabledAnimation,
    tooltipText = _generatePiggyBankIco.tooltipText;
  var _usePiggyBankTooltips = usePiggyBankTooltips({
      lastSpinEvents: lastSpinEvents,
      piggyBankCurrentProgress: piggyBankCurrentProgress
    }),
    triggerTooltip = _usePiggyBankTooltips.triggerTooltip;
  var handleClick = useCallback(function () {
    sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_WIDGET_CLICK);
    if (tooltipText) triggerTooltip(tooltipText);else QueryParamProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, screens.PiggyBank));
  }, [tooltipText, triggerTooltip]);
  var fillUpPercentage = getFillUpProgressPercentage(piggyBankFeatureState, localCounterValue);
  useEffect(function () {
    if (fillUpPercentage === 100) setTimeout(function () {
      return dispatch(invalidatePiggy());
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fillUpPercentage]);
  return useMemo(function () {
    return {
      piggyBankAssets: piggyBankAssets,
      piggyBankIcon: piggyBankIcon,
      disabledAnimation: disabledAnimation,
      handleClick: handleClick,
      fillPercentage: getFillUpProgressPercentage(piggyBankFeatureState, localCounterValue)
    };
  }, [piggyBankAssets, piggyBankIcon, disabledAnimation, handleClick, localCounterValue, piggyBankFeatureState]);
};
export default usePiggyBankWidget;